import type { FROM } from './index.h'

import { PasswordPolicyName } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { $policy } from './model'

// unified translations from FP-3631
export const $passwordI18n = combine(i18n.$t, $policy, ({ t }, policy) => {
  return (from: FROM) => {
    const targetPolicy = policy[from]

    const { name, min, max } = targetPolicy

    const policyMessage =
      name === PasswordPolicyName.DEFAULT
        ? t('password_default_error', { minLength: min })
        : t('password_strict_error', { minLength: min })

    return {
      // general
      label: t('password'),
      placeholder: t('enter_password'),
      // errors
      error: policyMessage,
      password: policyMessage,
      maxLength: t('password_max_length_error', { max_length: max }),
      minLength: policyMessage,
      required: t('password_required_error'),
      invalid: policyMessage,
      equalTo: t('confirm_password_match_error'),
      oldNewEqual: t('change_password_new_old_equal_error'),
      oldInvalid: t('change_password_old_invalid_error'),
    }
  }
})
